export const events = [
    // Friday September 4, 2026: 4 PM - 7 PM
    {
        id: 'fri-1',
        title: 'Registration + Reception',
        start: '2026-09-04T16:00:00',
        end: '2026-09-04T17:00:00',
        description: 'Initial registration and welcome reception',
        extendedProps: {
            type: 'events'
            }
    },
    {
    id: 'fri-2',
    title: 'Opening Ceremony + Keynote: Russ Poldrack',
    start: '2026-09-04T17:00:00',
    end: '2026-09-04T18:00:00',
    description: 'Opening ceremony and keynote presentation',
    extendedProps: {
        type: 'keynote',
        link: '#/speakers'
    }
},
{
    id: 'fri-3',
    title: 'Project Pitches',
    start: '2026-09-04T18:00:00',
    end: '2026-09-04T19:00:00',
    description: 'Teams present their initial project ideas',
    extendedProps: {
        type: 'hacking'
    }
},
// Saturday Events
{
    id: 'sat-1',
    title: 'Registration + Breakfast',
    start: '2026-09-05T09:00:00',
    end: '2026-09-05T10:00:00',
    description: 'Morning registration and breakfast',
    extendedProps: {
        type: 'events'
    }
},
{
    id: 'sat-2',
    title: 'Project Shopping Period + Hacking Commences',
    start: '2026-09-05T10:00:00',
    end: '2026-09-05T11:00:00',
    description: 'Official start of hacking period',
    extendedProps: {
        type: 'hacking'
    }
},
{
    id: 'sat-4',
    title: 'How to measure and reduce the carbon footprint of fMRI data analysis, Nick Souter',
    start: '2026-09-05T11:00:00',
    end: '2026-09-05T12:00:00',
    extendedProps: {
        type: 'educational',
        link: '#/speakers#educational-1'
    }
},
{
    id: 'sat-5',
    title: 'Sustainability in Scientific Research: Challenges and Opportunities, Jonathan Magnolia Gilligan',
    start: '2026-09-05T12:00:00',
    end: '2026-09-05T13:00:00',
    description: 'Educational sessions available on demand',
    extendedProps: {
        type: 'educational',
        link: '#/speakers#educational-2'
    }
},
{
    id: 'sat-6',
    title: 'Outdoor Social',
    start: '2026-09-05T13:00:00',
    end: '2026-09-05T14:00:00',
    description: 'Educational sessions available on demand',
    extendedProps: {
        type: 'events'
    }
},
{
    id: 'sat-7',
    title: 'Joining a World Wide Lab, Alex Maier',
    start: '2026-09-05T14:00:00',
    end: '2026-09-05T15:00:00',
    extendedProps: {
        type: 'educational',
        link: '#/speakers#educational-3'
    }
},
{
    id: 'sat-9',
    title: 'Cognitive Neuroscience in the Foundation Model Era: Lessons in Reproducibility, Hao-Ting Wang',
    start: '2026-09-05T15:00:00',
    end: '2026-09-05T16:00:00',
    extendedProps: {
        type: 'educational',
        link: '#/speakers#educational-4'
        //link: 'https://github.com/brainhack-vandy/traintrack'
    }
},
// {
//     id: 'sat-10',
//     title: 'Unconference',
//     start: '2026-09-05T15:30:00',
//     end: '2026-09-05T16:00:00',
//     extendedProps: {
//         type: 'unconference'
//     }
// },
{
    id: 'sat-12',
    title: 'Social',
    start: '2026-09-05T18:00:00',
    end: '2026-09-05T20:30:00',
    description: 'Evening social event',
    extendedProps: {
        type: 'events'
    }
},
// Sunday Events
{
    id: 'sun-1',
    title: 'Breakfast',
    start: '2026-09-06T09:00:00',
    end: '2026-09-06T09:30:00',
    description: 'Morning brunch',
    extendedProps: {
        type: 'events'
    }
},
{
    id: 'sun-2',
    title: 'Hacking Continued',
    start: '2026-09-06T09:30:00',
    end: '2026-09-06T12:30:00',
    description: 'Hacking period',
    extendedProps: {
        type: 'hacking'
    }
},
{
    id: 'sun-3',
    title: 'Project Presentations + Wrap Up',
    start: '2026-09-06T12:30:00',
    end: '2026-09-06T14:00:00',
    description: 'Final project presentations and event conclusion',
    extendedProps: {
        type: 'hacking'
    }
}
]